<ng-template #templateLoading>
  <div class="d-flex justify-content-center mt-4 mb-4">
    <div
      class="br-loading medium"
      role="progressbar"
      aria-label="Carregando..."
    ></div>
  </div>
  <div class="d-flex justify-content-center" *ngIf="message">
    <h6>{{ message }}</h6>
  </div>
</ng-template>
